<template>
  <div :id="cardId" class="vs-con-loading__container">
    <vx-card>
      <card-header
        :title="$t('ehs_status')"
        v-model="params.search"
        @search="search"
        @close="close"
      />
      <ehs-details :ehsId="item" />
      <ehs-table
        :data="items"
        @showDetails="showDetails"
        @loadMore="loadMore"
        @search="search"
      />
    </vx-card>
  </div>
</template>



<script>
import EhsTable from '../tables/EhsTable.vue'
import EhsDetails from '../sidebards/EhsDetails.vue'
import dashboard from '@/http/requests/dashboard'
import CardHeader from '../components/CardHeader.vue'

export default {
  name: 'ehs-card',
  components: {
    EhsDetails,
    EhsTable,
    CardHeader,
  },
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      cardTitle: 'Titulo',
      cardId: 'loading-ehs-card',
      items: [],
      item: '',
      lastPage: 1,
      loading: false,
      params: {
        page: 1,
        search: '',
        statusId: 1,
      },
    }
  },
  methods: {
    getData() {
      this.loading = true
      this.params.statusId = this.data.statusId
      if (this.data.statusId != null) {
        dashboard
          .ehsData(this.params)
          .then((response) => {
            if (this.params.page === 1) {
              this.items = []
              this.items = [...response.data.result.data]
              this.splitNames()
            } else {
              this.items = [...this.items, ...response.data.result.data]
              this.splitNames()
            }
            this.lastPage = response.data.result.last_page
            this.loading = false
          })
          .catch((response) => {
            this.showValidationErrors(response)
            this.loading = false
          })
      } else {
        dashboard
          .fullEhsData(this.params)
          .then((response) => {
            if (this.params.page === 1) {
              this.items = []
              this.items = [...response.data.result.data]
              this.splitNames()
            } else {
              this.items = [...this.items, ...response.data.result.data]
              this.splitNames()
            }
            this.lastPage = response.data.result.last_page
            this.loading = false
          })
          .catch((response) => {
            this.showValidationErrors(response)
            this.loading = false
          })
      }
    },
    loadMore() {
      if (this.params.page >= this.lastPage) {
        return
      }
      this.params.page++
      this.getData()
    },
    splitNames() {
      try {
        for (let i = 0; i < this.items.length; i++) {
          let name = String (this.items[i].name).trim()
          let divisor = name.length
          let partName1 = ''
          let partName2 = ''
          if (divisor > 60) {
            for (let j = 1; j < divisor; j++) {
              if (j < divisor / 2) partName1 += name[j]
              if (j > divisor / 2) partName2 += name[j]
            }
          } else {
            partName1 = name
          }
          let splitName = [partName1, partName2]
          this.items[i].name = splitName
        }
      } catch (error) {
        console.error(error)
      }
      try {
        for (let i = 0; i < this.items.length; i++) {
          let comments = String (this.items[i].observations).trim()
          let divisor = comments.length
          let partName1 = ''
          let partName2 = ''
          if (divisor > 45) {
            for (let j = 1; j < divisor; j++) {
              if (j < divisor / 2) partName1 += comments[j]
              if (j > divisor / 2) partName2 += comments[j]
            }
          } else {
            partName1 = comments
          }
          let splitName = [partName1, partName2]
          this.items[i].observations = splitName
        }
      } catch (error) {
        console.error(error)
      }
    },
    search() {
      this.params.page = 1
      this.getData()
    },
    close() {
      this.$emit('close', false)
    },
    showDetails(id) {
      this.item = id
      this.$store.dispatch('toggleSidebar', 'sidebar-ehs-details')
    },
  },
  mounted() {
    this.search()
  },
  watch: {
    loading(val) {
      if (val) {
        this.$vs.loading({
          container: `#${this.cardId}`,
          scale: 0.45,
        })
      } else {
        this.$vs.loading.close(`#${this.cardId} > .con-vs-loading`)
      }
    },
    data() {
      this.search()
    },
  },
}
</script>

